import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaInfoCircle, FaSearch, FaUndo, FaTrash, FaPlus } from "react-icons/fa";
import Pagination from "Components/Pagination";
import CommonModal from "Components/CommonModal";
import { catchError, changeState, commonModalSetting } from "JS/common";
import { statusList } from "JS/array";
import { getFileDownload, getApplicationList, deleteApplicationInfo } from "JS/API";
import { useMarkMenuSeen } from "Contexts/NewCountContext";
import useQueryParams from "utils/useQueryParams";
import useSyncPageWithQuery from 'utils/useSyncPageWithQuery';
import $ from "jquery";
import ApplicationForm from "Components/ApplicationForm";
import { listPageStyles } from "utils/designSystem";

const keyTranslations = {
  NORMAL: "일반출원",
  SEARCH: "조사출원",
  FAST: "신속출원",
  fast: "신속출원",
  FASTSEARCH: "신속조사출원",
};

const ApplicationInfo = () => {
  const { getQueryString, getQueryParamsObject, updateQueryParams, resetQueryParams } = useQueryParams();
  const [resetTrigger, setResetTrigger] = useState(false);
  const [pageInfo, setPageInfo] = useState(() => {
    const queryParams = getQueryParamsObject();
    return {
      page: Number(queryParams.page) || 1,
      limit: 10,
      totalPage: 1,
    };
  });
  useSyncPageWithQuery(setPageInfo)
  const [searchData, setSearchData] = useState(() => {
    const queryParams = getQueryParamsObject();
    return {
      markType: queryParams.markType || "all",
      progress: queryParams.progress || "all",
      applicantType: queryParams.applicantType || "all",
      applicationNum: queryParams.applicationNum || "",
      startDate: queryParams.startDate || "",
      endDate: queryParams.endDate || "",
      markName: queryParams.markName || "",
      user_id: queryParams.user_id || "",
      user_name: queryParams.user_name || "",
      sort: queryParams.sort || "apply_date_desc",
      priority_review_yn: queryParams.priority_review_yn || "",
      status: queryParams.status || ""
    }
  });
  const [alert, setAlert] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });
  const [list, setList] = useState([]);
  let prevent = false;
  const navigate = useNavigate();
  useMarkMenuSeen("application_info");
  // 체크된 항목 ID들을 저장하는 상태
  const [idArr, setIdArr] = useState([]);
  const [imageUrls, setImageUrls] = useState({});
  const [enterFloatSideBar, setEnterFloatSideBar] = useState(false);

  // 스타일 정의
  const styles = {
    container: listPageStyles.container,
    header: listPageStyles.header,
    title: listPageStyles.title,
    searchCard: listPageStyles.searchCard,
    searchRow: {
      display: 'flex',
      gap: '20px',
      marginBottom: '16px',
      flexWrap: 'wrap',
      alignItems: 'center'
    },
    searchField: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      minWidth: '200px'
    },
    searchLabel: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#374151',
      minWidth: '100px',
      flexShrink: 0
    },
    searchInput: {
      flex: 1,
      padding: '8px 12px',
      border: '1px solid #cbd5e1',
      borderRadius: '6px',
      fontSize: '14px',
      color: '#1e293b'
    },
    searchSelect: {
      flex: 1,
      padding: '8px 12px',
      border: '1px solid #cbd5e1',
      borderRadius: '6px',
      fontSize: '14px',
      backgroundColor: '#ffffff',
      color: '#1e293b',
      cursor: 'pointer'
    },
    buttonGroup: {
      display: 'flex',
      gap: '12px',
      justifyContent: 'flex-end',
      marginTop: '16px'
    },
    searchButton: listPageStyles.searchButton,
    resetButton: listPageStyles.resetButton,
    actionSection: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '12px',
      marginBottom: '16px'
    },
    deleteButton: listPageStyles.deleteButton,
    addButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      backgroundColor: '#10b981',
      color: '#ffffff',
      border: 'none',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    tableContainer: listPageStyles.tableContainer,
    tableWrapper: listPageStyles.tableWrapper,
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      minWidth: '1200px'
    },
    th: listPageStyles.th,
    td: listPageStyles.td,
    checkbox: listPageStyles.checkbox,
    checkboxLabel: listPageStyles.checkboxLabel,
    markImage: {
      width: '40px',
      height: '40px',
      objectFit: 'contain',
      borderRadius: '4px',
      border: '1px solid #e2e8f0'
    },
    applicationNumber: {
      fontFamily: 'monospace',
      fontSize: '13px',
      fontWeight: '500',
      color: '#374151'
    },
    priorityReview: {
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      backgroundColor: '#fee2e2',
      color: '#dc2626',
      textAlign: 'center'
    },
    applyType: {
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      textAlign: 'center'
    },
    typeNormal: {
      backgroundColor: '#dbeafe',
      color: '#1d4ed8'
    },
    typeSearch: {
      backgroundColor: '#dcfce7',
      color: '#16a34a'
    },
    typeFast: {
      backgroundColor: '#fef3c7',
      color: '#d97706'
    },
    markClasses: {
      fontSize: '12px',
      color: '#6b7280',
      lineHeight: '1.4'
    },
    status: {
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: '500',
      textAlign: 'center'
    },
    statusActive: {
      backgroundColor: '#dcfce7',
      color: '#16a34a'
    },
    statusInactive: {
      backgroundColor: '#fee2e2',
      color: '#dc2626'
    },
    statusPending: {
      backgroundColor: '#fef3c7',
      color: '#d97706'
    },
    statusBefore: {
      backgroundColor: '#f3e8ff',
      color: '#7c3aed'
    },

    statusAnnounce: {
      backgroundColor: '#ffe8fbff',
      color: '#ed3ad5ff'
    },
    userInfo: listPageStyles.userInfo,
    userName: {
      fontWeight: '500',
      marginBottom: '2px'
    },
    userId: {
      fontSize: '12px',
      color: '#6b7280'
    }
  };

  // 출원 유형별 스타일 반환
  const getApplyTypeStyle = (type) => {
    const baseStyle = styles.applyType;
    switch (type) {
      case 'NORMAL':
        return { ...baseStyle, ...styles.typeNormal };
      case 'SEARCH':
        return { ...baseStyle, ...styles.typeSearch };
      case 'FAST':
      case 'fast':
      case 'FASTSEARCH':
        return { ...baseStyle, ...styles.typeFast };
      default:
        return { ...baseStyle, ...styles.typeNormal };
    }
  };

  // 진행 상태별 스타일 반환
  const getStatusStyle = (status) => {
    const baseStyle = styles.status;
    switch (status) {
      case '등록':
        return { ...baseStyle, ...styles.statusActive };
      case '출원':
        return { ...baseStyle, ...styles.statusPending };
      case '출원 전':
        return { ...baseStyle, ...styles.statusBefore };
      case '공고':
        return { ...baseStyle, ...styles.statusAnnounce };
      case '소멸':
      case '포기':
      case '무효':
      case '취하':
        return { ...baseStyle, ...styles.statusInactive };
      default:
        return { ...baseStyle, ...styles.statusPending };
    }
  };

  const getList = async () => {
    if (prevent) return;
    prevent = true;
    setTimeout(() => (prevent = false), 200);

    try {
      const result = await getApplicationList(pageInfo, searchData);

      if (typeof result === "object" && result?.data) {
        const responseData = result.data;
        setList(responseData.data || []);

        const imageFetches = (responseData.data || []).map(async (item) => {
          if (item.image_filename && item.image_original_filename) {
            try {
              const url = await fetchUploadedImage(
                item.image_filename,
                item.image_original_filename
              );
              return { id: item.id, url };
            } catch (error) {
              console.error("이미지 URL 가져오기 오류:", error);
              return { id: item.id, url: null };
            }
          }
          return { id: item.id, url: null };
        });

        const resolvedImages = await Promise.all(imageFetches);
        const imageMap = {};
        resolvedImages.forEach(({ id, url }) => {
          if (url) imageMap[id] = url;
        });

        setImageUrls(imageMap);

        // 페이지네이션 정보 업데이트
        setPageInfo((prev) => ({
          ...prev,
          totalPage: responseData.meta?.total_page || 1,
        }));

        console.log("데이터 로드 완료:", responseData.data);
      } else {
        console.error("API 응답 형식이 예상과 다릅니다:", result);
        await catchError(result, navigate, setAlertBox, setAlert);
      }
    } catch (error) {
      console.error("API 호출 중 오류 발생:", error);
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "데이터 로드 중 오류가 발생했습니다."
      );
    }
  };

  const handleSearch = () => {
    setPageInfo((prev) => ({
      ...prev,
      page: 1,
    }));

    // 검색 데이터 정리 및 유효성 확인
    const trimmedApplicationNum = searchData.applicationNum.trim();
    const trimmedMarkName = searchData.markName.trim();
    const trimmedUserId = searchData.user_id.trim();

    const searchParams = {
      ...searchData,
      applicationNum: trimmedApplicationNum,
      progress: searchData.progress,
      markName: trimmedMarkName,
      user_id: trimmedUserId, // 사용자 ID
      priority_review_yn: searchData.priority_review_yn
    };

    updateQueryParams({ ...searchParams, page: 1 });
    // 검색 데이터 업데이트
    setSearchData(searchParams);

    // 검색 실행
    getList();
  };

  const renderList = () => {
    return list?.map(
      (
        {
          id,
          user_id,
          mark_name,
          mark_classes,
          application_number,
          application_date,
          status,
          internal_status,
          created_at,
          apply_type,
          user_name,
          priority_review_yn
        },
        idx
      ) => {
        const checkDragText = (e) => {
          const selection = window.getSelection();
          if (selection.toString().length > 0) {
            return;
          }
          navigate(`/application-info/${id}`);
        };

        // 체크박스 개별 선택
        const checkEach = (e) => {
          e.stopPropagation(); // 체크박스에서 모달 금지
          let all = $(".agencies-check").length;
          let checked = $(".agencies-check:checked").length;
          let arr = [];
          if (all !== checked) $(".agencies-all-check").prop("checked", false);
          else $(".agencies-all-check").prop("checked", true);
          for (let i = 0; i < all; i++) {
            if (document.getElementsByClassName("agencies-check")[i].checked) {
              const val =
                document.getElementsByClassName("agencies-check")[i].value;
              arr.push(val);
              setIdArr(arr);
            }
          }
        };

        const formattedMarkClasses = Array.isArray(mark_classes)
          ? mark_classes.map((cls) => `${cls}류`).join(", ")
          : "정보 없음";

        const formattedApplicationNumber = application_number?.length === 13
          ? `${application_number.slice(0, 2)}-${application_number.slice(2, 6)}-${application_number.slice(6)}`
          : application_number || "-";

        return (
          <tr
            key={id}
            onClick={() => checkDragText()}
            onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#f8fafc'}
            onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
          >
            <td style={styles.td} onClick={(e) => e.stopPropagation()}>
              <label style={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  className="agencies-check"
                  onChange={checkEach}
                  value={id}
                  style={styles.checkbox}
                />
              </label>
            </td>
            <td style={styles.td}>{id}</td>
            <td style={styles.td}>
              {imageUrls?.[id] && (
                <img
                  src={imageUrls[id]}
                  alt="썸네일"
                  style={styles.markImage}
                />
              )}
            </td>
            <td style={styles.td}>{mark_name || "-"}</td>
            <td style={styles.td}>
              <span style={styles.applicationNumber}>
                {formattedApplicationNumber}
              </span>
            </td>
            <td style={styles.td}>
              {priority_review_yn === 'Y' ? (
                <span style={styles.priorityReview}>우선심사</span>
              ) : (
                '-'
              )}
            </td>
            <td style={styles.td}>
              <span style={getApplyTypeStyle(apply_type)}>
                {keyTranslations[apply_type] || apply_type}
              </span>
            </td>
            <td style={styles.td}>
              <span style={styles.markClasses}>
                {formattedMarkClasses}
              </span>
            </td>
            <td style={styles.td}>
              <span style={getStatusStyle(status)}>
                {statusList[internal_status] || status || "-"}
              </span>
            </td>
            <td style={styles.td}>
              <div style={styles.userInfo}>
                <div style={styles.userName}>{user_name ? user_name : "-"}</div>
                <div style={styles.userId}>({user_id ? user_id : "-"})</div>
              </div>
            </td>
            <td style={styles.td}>{application_date || created_at?.split("T")[0] || "-"}</td>
          </tr>
        );
      }
    );
  };

  const fetchUploadedImage = async (fileName, originalFileName) => {
    try {
      const response = await getFileDownload(fileName, originalFileName);
      const base64 = btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );
      const mimeType = response.headers["content-type"];
      return `data:${mimeType};base64,${base64}`;
    } catch (error) {
      console.error("이미지 불러오기 실패:", error);
      return null;
    }
  };

  //=  삭제
  const deleteAgencies = async () => {
    const data = idArr;
    const result = await deleteApplicationInfo(data);
    if (typeof result === "object") {
      commonModalSetting(setAlertBox, true, "alert", "삭제되었습니다.");
      $(".agencies-all-check").prop("checked", false);
      $(".agencies-check").prop("checked", false);
      changeState(setPageInfo, "page", 1);
      setIdArr([]);
      setAlert("completeDelete");
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "정상적으로 삭제되었습니다."
      );
    } else return await catchError(result, navigate, setAlertBox, setAlert);
  };

  // 전체 선택
  const checkAll = () => {
    let arr = [];
    if ($(".agencies-all-check").is(":checked")) {
      $(".agencies-check").prop("checked", true);
      const all = $(".agencies-check").length;
      for (let i = 0; i < all; i++) {
        const val = document.getElementsByClassName("agencies-check")[i].value;
        arr.push(val);
        setIdArr(arr);
      }
    } else {
      $(".agencies-check").prop("checked", false);
      setIdArr([]);
    }
  };

  useEffect(() => {
    getList();
  }, [pageInfo.page, searchData.sort, resetTrigger]);

  useEffect(() => {
    document.title = "마크픽 관리자 > 출원 정보 관리";
  }, []);

  return (
    <div style={styles.container}>
      {/* 헤더 */}
      <div style={styles.header}>
        <h1 style={styles.title}>
          <FaInfoCircle />
          APPLICATION-INFORMATION
        </h1>
      </div>

      {/* 검색 영역 */}
      <div style={styles.searchCard}>
        {/* 첫 번째 행 */}
        <div style={styles.searchRow}>
          <div style={styles.searchField}>
            <label style={styles.searchLabel}>출원 번호</label>
            <input
              type="text"
              value={searchData.applicationNum}
              onChange={(e) =>
                changeState(setSearchData, "applicationNum", e.target.value)
              }
              style={styles.searchInput}
            />
          </div>
          <div style={styles.searchField}>
            <label style={styles.searchLabel}>진행 상태</label>
            <select
              value={searchData.status}
              onChange={(e) =>
                changeState(setSearchData, "status", e.target.value)
              }
              style={styles.searchSelect}
            >
              <option value="">선택</option>
              <option value="출원 전">출원전</option>
              <option value="출원">출원</option>
              <option value="등록">등록</option>
              <option value="소멸">소멸</option>
              <option value="포기">포기</option>
              <option value="무효">무효</option>
              <option value="취하">취하</option>
              <option value="공고">공고</option>
            </select>
          </div>
          <div style={styles.searchField}>
            <label style={styles.searchLabel}>우선심사 여부</label>
            <select
              value={searchData.priority_review_yn}
              onChange={(e) =>
                changeState(setSearchData, "priority_review_yn", e.target.value)
              }
              style={styles.searchSelect}
            >
              <option value="">선택</option>
              <option value="Y">Y</option>
              <option value="N">N</option>
            </select>
          </div>
        </div>

        {/* 두 번째 행 */}
        <div style={styles.searchRow}>
          <div style={styles.searchField}>
            <label style={styles.searchLabel}>출원인 이름</label>
            <input
              type="text"
              value={searchData.user_name}
              onChange={(e) =>
                changeState(setSearchData, "user_name", e.target.value)
              }
              style={styles.searchInput}
            />
          </div>
          <div style={styles.searchField}>
            <label style={styles.searchLabel}>출원인 아이디</label>
            <input
              type="text"
              value={searchData.user_id}
              onChange={(e) =>
                changeState(setSearchData, "user_id", e.target.value)
              }
              style={styles.searchInput}
            />
          </div>
          <div style={styles.searchField}>
            <label style={styles.searchLabel}>상표명</label>
            <input
              type="text"
              value={searchData.markName}
              onChange={(e) =>
                changeState(setSearchData, "markName", e.target.value)
              }
              style={styles.searchInput}
            />
          </div>
        </div>

        {/* 버튼 그룹 */}
        <div style={styles.buttonGroup}>
          <button
            style={styles.searchButton}
            onClick={handleSearch}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
          >
            <FaSearch />
            검색
          </button>
          <button
            style={styles.resetButton}
            onClick={() => {
              setSearchData((prev) => {
                const clone = { ...prev };
                clone.markType = "all";
                clone.progress = "all";
                clone.applicantType = "all";
                clone.applicationNum = "";
                clone.startDate = "";
                clone.endDate = "";
                clone.markName = "";
                clone.user_id = "";
                clone.user_name = "";
                clone.priority_review_yn = "";
                clone.queryParams = "apply_date_desc";
                clone.status = "";
                return clone;
              });
              setPageInfo((prev) => ({
                ...prev,
                page: 1,
              }));
              resetQueryParams();
              setResetTrigger((prev) => {
                const queryString = getQueryString();
                if (!queryString) return prev
                return !prev
              })
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
          >
            <FaUndo />
            초기화
          </button>
        </div>
      </div>

      {/* 액션 버튼 */}
      <div style={styles.actionSection}>
        <button
          style={styles.deleteButton}
          onClick={() => {
            if (!idArr.length)
              return commonModalSetting(
                setAlertBox,
                true,
                "alert",
                "삭제할 건을 선택해 주세요."
              );
            else {
              setAlert("deleteConfirm");
              commonModalSetting(
                setAlertBox,
                true,
                "confirm",
                "삭제하면 다시 복구할 수 없습니다.<br/>정말 삭제하시겠습니까?"
              );
            }
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
        >
          <FaTrash />
          삭제하기
        </button>
        <button
          style={styles.addButton}
          onClick={() => setEnterFloatSideBar(true)}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#059669'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#10b981'}
        >
          <FaPlus />
          신규생성
        </button>
      </div>

      {/* 테이블 */}
      <div style={styles.tableContainer}>
        <div style={styles.tableWrapper} className="table-wrapper">
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>
                  <label style={styles.checkboxLabel}>
                    <input
                      type="checkbox"
                      className="agencies-all-check"
                      onChange={checkAll}
                      style={styles.checkbox}
                    />
                  </label>
                </th>
                <th style={styles.th}>No.</th>
                <th style={styles.th}>상표이미지</th>
                <th style={styles.th}>상표명</th>
                <th style={styles.th}>출원 번호</th>
                <th style={styles.th}>우선심사 여부</th>
                <th style={styles.th}>출원 유형</th>
                <th style={styles.th}>상품 분류</th>
                <th style={styles.th}>진행 상태</th>
                <th style={styles.th}>사용자정보</th>
                <th style={styles.th}>출원일</th>
              </tr>
            </thead>
            <tbody>{renderList()}</tbody>
          </table>
        </div>
      </div>

      {/* 페이지네이션 */}
      <Pagination pageInfo={pageInfo} setPageInfo={setPageInfo} />

      {/* 모달들 */}
      {enterFloatSideBar && (
        <ApplicationForm
          setEnterFloatSideBar={setEnterFloatSideBar}
          getList={getList}
        />
      )}
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "deleteConfirm") deleteAgencies();
            else if (alert === "completeDelete") getList();
            else if (alert === "logout") navigate("/");
            else return;
          }}
        />
      )}

      {/* 반응형 스타일 */}
      <style>{`
        @media (max-width: 768px) {
          .table-wrapper {
            -webkit-overflow-scrolling: touch;
          }
          
          .table-wrapper::-webkit-scrollbar {
            height: 8px;
          }
          
          .table-wrapper::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 4px;
          }
          
          .table-wrapper::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 4px;
          }
          
          .table-wrapper::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
        }
      `}</style>
    </div>
  );
};

export default ApplicationInfo;